export default __webpack_public_path__ + "static/media/eng2.e4735fa8.jpg";